/**
 * Single source of truth for the frontend product brand.
 *
 * Change these two constants to rebrand the entire frontend — they feed both:
 *  - runtime UI + tab title, via `config.ts` (as the defaults for
 *    appName/appFullName; an explicit VITE_APP_NAME / VITE_APP_FULL_NAME env
 *    var still overrides if you ever need per-deploy branding), and
 *  - the `index.html` first-paint <title>, via the `brandHtmlPlugin` build hook
 *    in `vite.edition.ts` (so there is no pre-JS flash and no brand string baked
 *    into the HTML).
 *
 * The backend's equivalent single source is
 * `website-backend/src/common/branding.rs`.
 */

/** Short/compact brand — logo, headings, the "N" glyph. */
export const APP_NAME = 'Witina';

/** Full product name — body copy and the browser-tab title. */
export const APP_FULL_NAME = 'Witina AI';

/**
 * The brand colour as sRGB hex — the same colour `tokens.css` spells
 * `oklch(0.55 0.18 250)` for `--primary`, converted once here.
 *
 * Hex, not oklch, because the consumers cannot parse CSS Color 4:
 *  - the PWA manifest's `theme_color` / `background_color`, and
 *  - the SVG → PNG rasterizer that generates the app icons at build time
 *    (`pwaPlugin` in `vite.edition.ts`). resvg and librsvg fail on `oklch()` by
 *    rendering a blank square rather than by erroring, so this is not a
 *    convenience — an oklch value there ships broken icons silently.
 *
 * Mirrors `--primary` in `src/styles/tokens.css`, the same way `index.html`'s
 * two `theme-color` metas already do. Change one, change all of them.
 */
export const BRAND_COLOR_HEX = '#0072d5';
